import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export const TransformationSummary = () => {
  return <section className="mb-12" data-id="element-432" data-mp="2il6pnx3xdbom">
      <p className="mb-6 text-gray-800 leading-relaxed" data-id="element-433" data-mp="2imhxq94el5lj">
        Lisa herkent dit moment: "Het kwartje viel toen Amee uitlegde hoe honden
        vanuit hun natuur gewend zijn met elkaar om te gaan. Ik begreep dat
        Benny helemaal niet koppig was - hij begreep mij gewoon niet, net zoals
        ik hem niet begreep. We hadden gewoon langs elkaar heen gecommuniceerd."
      </p>

      <div className="bg-blue-50 border border-blue-100 rounded-xl p-8" data-id="element-434" data-mp="31ihrnpgxyj7r">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-435" data-mp="2mnbiitmju4a7">
          Wat deelnemers ontdekken:
        </h3>

        <div className="space-y-5 mb-8" data-id="element-436" data-mp="2rklgwyrx1qa6">
          <div className="flex items-start" data-id="element-437" data-mp="2rnprqezvzk9t">
            <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-438" data-mp="1b73ndd9g5v8k" />
            <p className="text-lg text-gray-800" data-id="element-439" data-mp="1g6ziso42weci">
              <span className="font-bold" data-id="element-440" data-mp="1g7ravoygvty1">Dat onrustige gedrag?</span> Vaak
              mentale vermoeidheid, niet fysieke energie.
            </p>
          </div>
          <div className="flex items-start" data-id="element-441" data-mp="3cm99f6sfmm3x">
            <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-442" data-mp="3cnkbn268blsx" />
            <p className="text-lg text-gray-800" data-id="element-443" data-mp="3qiw6raoaread">
              <span className="font-bold" data-id="element-444" data-mp="3llmhbv0wr2mj">Die korte blikken naar de deur?</span>{' '}
              Je hond probeert je mee te nemen naar iets interessants.
            </p>
          </div>
          <div className="flex items-start" data-id="element-445" data-mp="3vkli6rffltyz">
            <CheckCircle2Icon className="w-7 h-7 text-green-500 mr-4 mt-0.5 flex-shrink-0" data-id="element-446" data-mp="3vjtltee0fs7n" />
            <p className="text-lg text-gray-800" data-id="element-447" data-mp="d5kqnw1u8zxz">
              <span className="font-bold" data-id="element-448" data-mp="94r3j4w7zp65">
                Dat wegkijken wanneer je hem roept?
              </span>{' '}
              Respect, geen negeren.
            </p>
          </div>
        </div>

        <p className="text-lg text-gray-800 leading-relaxed italic" data-id="element-449" data-mp="i5fchl6razc6">
          In 90 minuten leer je eindelijk wat je hond al die tijd probeerde te
          zeggen. Het eerstvolgende gratis{' '}
          <span className="text-blue-600 not-italic" data-id="element-450" data-mp="3fyh40s1z85zf">webinar</span> is vandaag
          en morgen.
        </p>
      </div>

      <p className="text-xl text-gray-900 font-bold text-center mt-8" data-id="element-451" data-mp="3kwsft8bu0qka">
        Soms kan anderhalf uur alles veranderen in de relatie met je hond
      </p>
    </section>;
};